import React, { useState, useContext, useEffect } from 'react'
import { StaticQuery, graphql, navigate } from 'gatsby';
import { withPreview } from '@prismicio/gatsby-source-prismic-graphql';
import Cookies from 'universal-cookie';
import get from 'lodash/get';

import { getLinkPropsFromReference, getLinkPropsFromMeta, getPathFromMeta, getHomePath } from '../../utils/link'
import { getDataLayer } from '../../utils/gtm'
import { logData } from '../../services/gtm'

import { SIZE } from '../../theme/metrics'

import PageMetaContext from '../../context/page-meta-context';
import { useWindowWidth } from '../../hooks/window-width';

import { Container, Content, Burger, BurgerIcon, BurgerLabel, BurgerOpen, BurgerClose, Logo, LogoMark, Menu, Navigation, NavigationList, NavigationListItem, NavigationLink, Group, GroupHeader, GroupList, GroupListItem, GroupArrow, GroupLink, GroupListItemIcon, GroupListItemLabel, GroupListItemDescription, Locale, LocaleHeader, LocaleLabel, LocaleDropdown, LocaleArrow, LocaleLink, ButtonList, ButtonListItem, ButtonLink, CountryList, CountryItem, CountryLabel, CountryFlag, LanguageList, LanguageItem, LanguageLabel } from './header.styles'

const headerQuery = graphql`
query {
	site {
		siteMetadata {
			siteUrl
		}
	}
	prismic {
		allConfigurations {
			edges {
				node {
					_meta{
						lang
						alternateLanguages {
							lang
						}
					}
					live
					flag
					language
					label_menu
					label_close
					body {
					... on PRISMIC_ConfigurationBodyCountry {
							primary {
								code
								domain
								name
							}
							fields {
								code
								name
							}
						}
					}
				}
			}
		}
		allHeaders {
			edges {
				node {
					_meta{
						lang
					}
					buttons {
						label
						link {
							_linkType
							... on PRISMIC_Home {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Complex {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Simple {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Product {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Article {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Blog {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Contact {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Form {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC_Legal {
								_meta {
									lang
									type
									uid
								}
							}
							... on PRISMIC__ExternalLink {
								url
							}
							... on PRISMIC__FileLink {
								url
							}
							... on PRISMIC__ImageLink {
								url
							}
						}
					}
					body {
						... on PRISMIC_HeaderBodyGroup {
							type
							primary {
								label
								link {
									_linkType
									... on PRISMIC_Home {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Complex {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Simple {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Product {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Article {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Blog {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Contact {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Form {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Legal {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC__ExternalLink {
										url
									}
									... on PRISMIC__FileLink {
										url
									}
									... on PRISMIC__ImageLink {
										url
									}
								}
							}
							fields {
								label
								description
								icon
								link {
									_linkType
									... on PRISMIC_Home {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Complex {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Simple {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Product {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Article {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Blog {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Contact {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Form {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Legal {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC__ExternalLink {
										url
									}
									... on PRISMIC__FileLink {
										url
									}
									... on PRISMIC__ImageLink {
										url
									}
								}
							}
						}
						... on PRISMIC_HeaderBodyLink {
							type
							primary {
								label
								link {
									_linkType
									... on PRISMIC_Home {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Complex {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Simple {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Product {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Article {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Blog {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Contact {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Form {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC_Legal {
										_meta {
											lang
											type
											uid
										}
									}
									... on PRISMIC__ExternalLink {
										url
									}
									... on PRISMIC__FileLink {
										url
									}
									... on PRISMIC__ImageLink {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
`;

const renderBody = (body) => {
	return body.map((item, index) => {
		switch(item.type){
			case 'group': return (
				<NavigationListItem key={index}>
					{renderGroup(item.primary,item.fields)}
				</NavigationListItem>
			)
			case 'link': return (
				<NavigationListItem key={index}>
					<NavigationLink {...getLinkPropsFromReference(item.primary.link)}>{item.primary.label}</NavigationLink>
				</NavigationListItem>
			)
		}
		return null;
	})
}

const renderGroup = (primary,fields) => {
	const [hover, setHover] = useState(false);

	const handleEnter = event => setHover(true);
	const handleLeave = event => setHover(false);

	return(
		<Group onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
			<NavigationLink {...getLinkPropsFromReference(primary.link)}>
				{primary.label}
				<GroupArrow width="11" height="7" viewBox="0 0 11 7" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.08816 6.43596L10.1602 1.34796L9.39216 0.563965L5.08816 4.86796L0.784156 0.563964L0.000155415 1.33196L5.08816 6.43596Z" />
				</GroupArrow>
			</NavigationLink>
			<GroupList hover={hover}>
				{fields.map((field,index) => (
					<GroupListItem key={index}>
						<GroupLink {...getLinkPropsFromReference(field.link)}>
							<GroupListItemLabel>{field.label}</GroupListItemLabel>
							<GroupListItemDescription>{field.description}</GroupListItemDescription>
						</GroupLink>
					</GroupListItem>
				))}
			</GroupList>
		</Group>
	)
}

const LocaleSelector = ({language,configuration,alternates}) => {

	const [hover, setHover] = useState(false);
	const [active, setActive] = useState(false);

	const handleEnter = event => setHover(true);
	const handleLeave = event => setHover(false);
	const handleClick = event => {
		event.preventDefault();
		setActive(!active);
	}

	const languageCode = language.split('-')[0];
	const countryCode = language.split('-')[1];

	return(
		<Locale onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
			<LocaleHeader onClick={handleClick}>
				<CountryFlag code={countryCode} />
				<LocaleLabel>{languageCode}</LocaleLabel>
				<LocaleArrow width="11" height="7" viewBox="0 0 11 7" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.08816 6.43596L10.1602 1.34796L9.39216 0.563965L5.08816 4.86796L0.784156 0.563964L0.000155415 1.33196L5.08816 6.43596Z" />
				</LocaleArrow>
			</LocaleHeader>

			<LocaleDropdown hover={hover} active={active}>
				<Countries language={language} configuration={configuration} alternates={alternates} />
			</LocaleDropdown>

		</Locale>
	)
}

const Countries = ({language,configuration,alternates}) => {
	return (
		<CountryList>
			{configuration.body && configuration.body.filter(c => c.primary.code == language.split('-')[1] || alternates.some(alternate => alternate.lang.split('-')[1] == c.primary.code)).map(country => (
				<CountryItem key={country.primary.code}>
					<CountryLabel selected={country.primary.code === language.split('-')[1]}>{country.primary.name}<CountryFlag code={country.primary.code} /></CountryLabel>
					<Languages language={language} country={country} configuration={configuration} alternates={alternates} />
				</CountryItem>
			))}
		</CountryList>
	)
}

const Languages = ({language,country,configuration,alternates}) => {
	const meta = useContext(PageMetaContext);
	const countryCode = country.primary.code;

	return (
		<LanguageList>
			{country.fields.filter(l => language.split('-')[0] === l.code || alternates.some(alternate => alternate.lang.split('-')[0] === l.code && alternate.lang.split('-')[1] === country.primary.code)).map(lang => {
				const languageCode = lang.code ? lang.code.split('-').shift() : null;
				const href = `/${languageCode ? languageCode : ''}${languageCode && countryCode ? '-' : ''}${countryCode ? countryCode : ''}/`;

				return (
					<LanguageItem key={lang.code}>
						<LanguageLabel selected={language.split('-')[0] === languageCode && language.split('-')[1] === countryCode} href={href} onClick={(event) => {
							event.preventDefault();

							if(window.Cookiebot && window.Cookiebot.consent.preferences){
								// cookie expires in 6 months
								const cookies = new Cookies();
								if(languageCode){
									cookies.set('nf_lang', languageCode, { path: '/', maxAge: 6 * 28 * 24 * 60 * 60})
								}
								if(countryCode){
									cookies.set('nf_country', countryCode, { path: '/', maxAge: 6 * 28 * 24 * 60 * 60})
								}
							}
							
							
							logData(getDataLayer({block:"header",meta},`locale-${language}`))

							window.location.href = href;
						}}>
							{lang.name}
						</LanguageLabel>
					</LanguageItem>
				)
			})}
		</LanguageList>
	)
}

const Header = ({language}) => {
	const meta = useContext(PageMetaContext);

	return (
		<StaticQuery
			query={`${headerQuery}`}
			render={withPreview(data => {
				const site = get(data,"site.siteMetadata");
				const headers = get(data,"prismic.allHeaders.edges",[]).map(edge => edge.node);
				const header = headers.find(node => node._meta.lang === language);
				const configurations = get(data,"prismic.allConfigurations.edges",[]).map(edge => edge.node);
				const configuration = configurations.find(node => node._meta.lang === language);

				const alternates = configuration._meta.alternateLanguages.filter(alternate => configurations.some(config => config._meta.lang === alternate.lang && (site.includeDraftLanguages || config.live)));

				// check all relevant content exists
				if(!header) return null;

				const [active, setActive] = useState(false);

				const [windowWidth, breakpoint] = useWindowWidth();

				useEffect(() => {
					if(breakpoint !== SIZE.small && breakpoint !== SIZE.medium){
						setActive(false);
					}
				}, [breakpoint])

				useEffect(() => {
					if(document){
						if(active){
							document.querySelector('html').style.overflow = 'hidden';
						}
						else{
							document.querySelector('html').style.overflow = 'visible';
						}
					}
				}, [active])

				const handleClick = event => setActive(!active);


				return (
					<Container>
						<Content>
							<Logo to={getHomePath(language)}>
								<LogoMark width="147" height="21" viewBox="0 0 147 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M37.7914 7.51798C37.7914 5.62916 36.6267 5.09163 34.2526 5.09163H31.0349V10.1683H34.2526C36.664 10.1683 37.7914 9.37695 37.7914 7.51798ZM43.5922 7.51798C43.5922 12.1318 40.0983 15.2375 34.5512 15.2375H31.0274V20.3142H25.2788V0H34.5662C40.1132 0.00746572 43.5922 2.87431 43.5922 7.51798Z" fill="#191919"/>
									<path d="M55.7912 10.1684L53.9695 5.09173L52.1479 10.1684H55.7912ZM57.8069 15.2376H50.1396L48.0791 20.3218H42.2185L51.1848 0.00756836H56.8439L65.84 20.3218H59.86L57.8069 15.2376Z" fill="#191919"/>
									<path d="M76.001 15.2451V20.3218H70.2523V15.2451L62.5029 0.00756836H68.5726L73.3879 10.161L78.2033 0.00756836H83.7802L76.001 15.2451Z" fill="#191919"/>
									<path d="M93.9633 5.09163H90.8949L89.9542 10.1683L93.1719 10.1608C95.7327 10.1608 97.2184 9.22017 97.2184 7.02524C97.2109 5.31559 95.9343 5.09163 93.9633 5.09163ZM97.3826 14.2222L100.832 20.3142H94.8219L91.9849 15.2375H88.8344L87.8265 20.3142H82.0779L86.1392 0H94.8144C100.011 0 102.997 2.41143 102.997 6.47278C103.019 10.2206 100.929 13.0053 97.3826 14.2222Z" fill="#191919"/>
									<path d="M117.174 10.1608L116.219 5.09163L113.494 10.1608H117.174ZM118.219 15.2301H110.5L107.461 20.3142H101.399L114.427 0H120.086L124.991 20.3142H119.272L118.219 15.2301Z" fill="#191919"/>
									<path d="M136.137 15.2451L135.159 20.3218H129.418L130.463 15.2451L125.7 0.00756836H131.479L134.234 10.1684L141.169 0.00756836H147L136.137 15.2451Z" fill="#191919"/>
									<path d="M16.2977 16.3052L14.4536 14.4612L12.5349 12.5425L10.1459 10.1535L7.81661 7.81672L7.60757 7.61514L5.85313 5.8607L5.06922 5.0768L3.99416 4.00173L2.53835 2.53845L0 0.00756836V2.53845L2.53835 5.0768L3.13561 5.67406L5.06922 7.61514L5.18868 7.73459L7.60757 10.1535L8.08537 10.6238L9.72783 12.2738L12.5797 15.1256L14.6253 17.1713L17.7609 20.3069H20.2993L16.2977 16.3052Z" fill="#191919"/>
									<path d="M9.98167 15.0658L5.25587 10.3325L5.07669 10.1534L2.613 7.69712L2.53835 7.615L0 5.07666V7.615L2.53835 10.1534L2.64287 10.2579L10.0414 17.6639L12.6843 20.3067H15.2226L12.6096 17.6863L9.98167 15.0658Z" fill="#191919"/>
									<path d="M20.2097 7.61503C20.0828 6.71914 19.8215 5.86806 19.4482 5.07669C18.9928 4.12854 18.3806 3.26998 17.634 2.53834C16.0364 0.970539 13.8414 0 11.4226 0H0L2.53835 2.53834H5.20361H11.43C13.5055 2.53834 15.3495 3.53129 16.5067 5.07669C17.0592 5.8158 17.4549 6.67435 17.649 7.61503C17.7311 8.02565 17.7759 8.45119 17.7759 8.8842C17.7759 9.31721 17.7311 9.74277 17.649 10.1534C17.2682 12.0123 16.0737 13.5801 14.4611 14.4611L16.3051 16.3051C18.3806 14.9389 19.8439 12.7216 20.2172 10.1534C20.2769 9.74277 20.3068 9.31721 20.3068 8.8842C20.3068 8.45119 20.2694 8.03311 20.2097 7.61503Z" fill="#191919"/>
									<path d="M15.275 8.88417C15.275 8.43623 15.2003 8.01068 15.0585 7.615C14.5359 6.13679 13.1248 5.07666 11.4675 5.07666H6.35344H5.06934L5.84577 5.86056L7.60021 7.615H7.86898H11.4077C12.1095 7.615 12.6769 8.18239 12.6769 8.88417C12.6769 9.58595 12.1095 10.1534 11.4077 10.1534H10.1386L12.5201 12.5424C13.6997 12.199 14.6404 11.3031 15.0435 10.1534C15.2003 9.75767 15.275 9.33211 15.275 8.88417Z" fill="#191919"/>
									<path d="M0 12.6919V15.2302V17.7686V20.3069H2.53835H5.07669H7.60757V17.7686L0 10.1536V12.6919Z" fill="#191919"/>
								</LogoMark>
							</Logo>
							<Menu active={active}>
								<Navigation>
									<NavigationList>
										{renderBody(header.body)}
									</NavigationList>
									<ButtonList>
										{header.buttons.map((button,index) => {
											const props = getLinkPropsFromReference(button.link)

											return (
												<ButtonListItem key={index}>
													<ButtonLink {...props} onClick={(e) => {
														logData(getDataLayer({block:"header",meta},button.label))
														if(props.to){
															e.preventDefault();
															navigate(props.to);
														}
													}}>{button.label}</ButtonLink>
												</ButtonListItem>
											)
										})}
									</ButtonList>
								</Navigation>
								<LocaleSelector language={language} configuration={configuration} alternates={alternates} />
							</Menu>
							<Burger active={active} onClick={handleClick}>
								<BurgerIcon />
								<BurgerLabel>
									<BurgerOpen>{configuration.label_menu}</BurgerOpen>
									<BurgerClose>{configuration.label_close}</BurgerClose>
								</BurgerLabel>
							</Burger>
						</Content>
					</Container>
				)

			}, headerQuery)}
		/>
	)
};

export default Header;
